// Copyright (c) 2016 Deere & Company

import AlertMessage from './alert-message';
import t from 'tcomb';

const AlertMessages = t.struct({
    errorMessages: t.list(AlertMessage, 'ErrorMessages'),
    infoMessages: t.list(AlertMessage, 'InfoMessages'),
    successMessages: t.list(AlertMessage, 'SuccessMessages'),
    warningMessages: t.list(AlertMessage, 'WarningMessages')
}, 'AlertMessages');

export const getDefaultState = () => new AlertMessages({
    errorMessages: [],
    infoMessages: [],
    successMessages: [],
    warningMessages: []
});

export default AlertMessages;



// WEBPACK FOOTER //
// ./src/shared/state/alert-messages.js